import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom';
import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';
import gamerules from '../imagesHome/game-rules.png';
import typeaccount from '../imagesHome/game02.png';
import accountsplan from '../imagesHome/accountsplan.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import './CourseCarousel.css';

const listaCursuri = [
  {
    id: 1,
    titlu: 'Bazele contabilitatii',
    imagine: bazeleconta,
    culoare: 'card-curs-pp-bc',
    link: '/bazeleconta'
  },
  {
    id: 2,
    titlu: 'Contabilitate financiara',
    imagine: contafinanciara,
    culoare: 'card-curs-pp-cf',
    link: '/contafinanciara'
  },
  /*
  {
    id: 3,
    titlu: 'Regulile de functionare',
    imagine: gamerules,
    culoare: 'card-curs-pp-gr',
    link: '/PageGameFinancialRulesOff'
  },
  {
    id: 4,
    titlu: 'Identifica tipul contului',
    imagine: typeaccount,
    culoare: 'card-curs-pp-ta',
    link: '/PageGameTypeAccountOff'
  },
  {
    id: 5,
    titlu: 'Planul de conturi',
    imagine: accountsplan,
    culoare: 'card-curs-pp-ap',
    link: '/PageGameAccoutPlanOff'
  },
  */
];


const CursuriCarousel = () => {
 const elemente = listaCursuri.map((curs) => (
  <div className='background-lectii-carusel'>
    <Link
      to={curs.link} // ✅ folosim "to" pentru react-router
      key={curs.id}
      className={curs.culoare}
      
    >
      <img src={curs.imagine} alt={curs.titlu} />
      <span className='titlu-lectie-fp'>{curs.titlu}</span>
    </Link>

  </div>
  
));


  return (
    <div className="sectiune-cursuri-pp">
     
      <div className="container-cursuri-pp">
        <AliceCarousel
  items={elemente}
  infinite
  mouseTracking
  disableDotsControls
  controlsStrategy="responsive"
  touchMoveDefaultEvents={false}  // 👈 Asta oprește scrollul vertical
  responsive={{
    0: { items: 3 },
    768: { items: 3 },
    1024: { items: 3 }
  }}
  renderPrevButton={() => (
    <div className="sageata-cursuri-pp stanga-pp">
      <FontAwesomeIcon icon={faChevronLeft} className='size-first-page-arrows' />
    </div>
  )}
  renderNextButton={() => (
    <div className="sageata-cursuri-pp dreapta-pp">
      <FontAwesomeIcon icon={faChevronRight} className='size-first-page-arrows' />
    </div>
  )}
/>

      </div>
    </div>
  );
};

export default CursuriCarousel;
